export default __webpack_public_path__ + "static/media/iab-active-banner.c06b8f9f.svg";